import { Api } from './base/Api';
export class LarekApi extends Api {
    constructor(baseUrl, options) {
        super(baseUrl, options);
    }
    getCatalog() {
        return this.get('/product').then((data) => data.items);
    }
    getProductById(id) {
        return this.get(`/product${id}`).then((item) => item);
    }
    order(order) {
        return this.post(`/order`, order).then((data) => data);
    }
}
